module.exports = __webpack_public_path__ + "img/pattern_top.fc54c7ef.png";